import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useVendorsStore } from "../store/vendors.store";
import { useVendorsWarehouseSale } from "../hook/partner/vendors.partner.hook";
import { PartnerApi } from "../api/partner.api";
import { NavLink, useParams } from "react-router";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import VendorDetailProductSets from "./Vendors/Detail/VendorDetailProductSets";
import { useVendor } from "../hook/partner/vendor.partner.hook";
import VendorDetailWarehouseSales from "./Vendors/Detail/VendorDetailWarehouseSales";
import { useTranslation } from "../hooks/useTranslation";

function WarehouseSale() {
  const { t } = useTranslation();
  let { vendorId } = useParams();
  if (typeof vendorId === "undefined") {
    vendorId = null;
  }

  const vendorsMutation = useVendorsWarehouseSale();
  const vendorMutation = useVendor();

  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const vendors = useVendorsStore((state) => state.vendors);
  const vendor = useVendorsStore((state) => state.vendor);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    if (vendorId && vendor && vendorId == vendor?.vendor_id) {
      setPagename(vendor ? vendor.name : "");
      setBreadcrumbs([
        {
          name: t("navigation.clearance"),
          link: "/vyprodej",
        },
      ]);
    } else {
      setPagename(t("navigation.clearance"));
      setBreadcrumbs([]);
    }
  }, [vendorId, vendor]);

  useEffect(() => {
    if (token) {
      vendorsMutation.mutate({ token });
    }
  }, [token]);

  useEffect(() => {
    if (token && vendorId) {
      vendorMutation.mutate({ token, vendorId });
    }
  }, [token, vendorId]);

  let vendorsMy = [];
  if (vendors && vendors.length > 0) {
    user?.role?.forEach((role) => {
      if (role.role_id === "vendors") {
        role.val?.forEach((val) => {
          vendorsMy = vendorsMy.concat(
            vendors.filter((v) => v.vendor_id === val.vendor_id)
          );
        });
      }
    });
  }

  return (
    <>
      {vendorId !== null ? (
        vendor?.vendor_id == vendorId ? (
          <VendorDetailWarehouseSales vendor={vendor} />
        ) : (
          <p>{t("common.loading")}</p>
        )
      ) : (
        <div className="row">
          {vendorsMy?.length > 0 ? (
            <>
              {vendorsMy?.map((vendor, vendor_key) => (
                <div key={vendor_key} className="col-12 col-sm-6 col-md-3 p-5">
                  <NavLink
                    to={`/vyprodej/${vendor.vendor_id}`}
                    className={
                      "card p-5 d-flex justify-content-center align-items-center h-100"
                    }
                  >
                    <img
                      className="mw-100"
                      style={{
                        aspectRatio: "1 / 1",
                        objectFit: "contain",
                      }}
                      src={
                        PartnerApi.url +
                        "/vendor/" +
                        vendor.vendor_id +
                        "/logo.jpg"
                      }
                      alt={vendor.name}
                    />
                  </NavLink>
                </div>
              ))}
            </>
          ) : (
            <>-</>
          )}
        </div>
      )}
    </>
  );
}

export default WarehouseSale;
